import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { EXTERNAL_USER_ROLES } from "../constants";

export const useExternalUserRedirect = () => {
  const navigate = useNavigate();
  const userDetails = useSelector((state) => state.user);

  useEffect(() => {
    if (!userDetails?.role) return;

    const isExternalUser = EXTERNAL_USER_ROLES.includes(userDetails.role);

    if (userDetails.role !== "MedlineAdministrator" && userDetails.customerSettings?.ne1Wms === 0 && isExternalUser) {
      navigate("/learnMore");
    }
  }, [userDetails, navigate]);
};
